import { gql } from "@apollo/client";

export const notificationMessage = gql`
  subscription notificationMessage($userId: String) {
    onNotificationMutation(userId: $userId) {
      id
      visionId
      isCommunicationNotification
      isVisionNotification
      companyId
      targetId
      notificationType
      message {
        isPerformanceReview
        title
        successStoryType
        successStoryCreator
        successStoryTitle
        description
        targetId
        target {
          title
          type
          logo {
            fileName
          }
        }
        documentName
        parentMessageId
        grandParentMessageId
        gifUrl
        documentUrl
        objectId
      }
      source
      Isread
      createdAt
      updatedAt
      isDeleted
      createdByUserId
      user {
        firstName
        lastName
        profileImage {
          fileName
        }
      }
      createdBy {
        firstName
        lastName
        profileImage {
          url
          fileName
        }
      }
    }
  }
`;

export const updateNotificationMutation = gql`
  mutation updateNotificationMutation($input: UpdateNotificationInput!) {
    updateNotification(input: $input) {
      userId
      id
      Isread
    }
  }
`;
